<template>
  <div>
    <div class="tw-flex">
      <div
        class="tw-flex tw-h-12 tw-max-h-[40px] tw-cursor-pointer tw-flex-row tw-items-center tw-border-gray-300"
        :class="{ 'tw-w-36': !mobileWidth }"
      >
        <button
          class="tw-ml-1 tw-flex tw-h-[40px] tw-w-[40px] tw-select-none tw-flex-row tw-content-center tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 hover:tw-bg-uhblue-100 focus-visible:tw-ring focus-visible:tw-ring-sky-200 focus-visible:tw-ring-opacity-50 focus-visible:tw-ring-offset-1 disabled:tw-bg-transparent hover:disabled:tw-bg-transparent"
          :dusk="`stepper-${dusk}-minus`"
          :data-testid="testId ? `${testId}-decrement` : null"
          type="button"
          :disabled="currentValue <= min"
          @click.prevent="decreaseValue"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 16H27"
              :stroke="currentValue <= min ? '#D1D5DB' : '#00A2E1'"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span class="tw-sr-only">Minus button</span>
        </button>

        <div
          class="tw-flex tw-h-full tw-w-[60px] tw-flex-col tw-content-center tw-items-center tw-justify-center tw-text-center tw-text-[16px]"
          :dusk="`stepper-${dusk}-value`"
          :data-testid="testId ? `${testId}-value` : null"
        >
          {{ displayValue(currentValue) }}
        </div>

        <button
          type="button"
          :disabled="currentValue >= max"
          :dusk="`stepper-${dusk}-plus`"
          :data-testid="testId ? `${testId}-increment` : null"
          class="tw-flex tw-h-[40px] tw-w-[40px] tw-select-none tw-flex-row tw-content-center tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 hover:tw-bg-uhblue-100 focus-visible:tw-ring focus-visible:tw-ring-sky-200 focus-visible:tw-ring-opacity-50 focus-visible:tw-ring-offset-1 disabled:tw-bg-transparent hover:disabled:tw-bg-transparent"
          @click.prevent="increaseValue"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :stroke="currentValue >= max ? '#D1D5DB' : '#00A2E1'"
          >
            <path
              d="M5 16H27"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 5V27"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span class="tw-sr-only">Plus button</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UhNumberStepperRound',
  props: {
    existingValue: {
      type: Number,
      required: false,
      default: 0,
    },
    min: {
      type: Number,
      required: false,
      default: 0,
    },
    max: {
      type: Number,
      required: false,
      default: 0,
    },
    defaultValue: {
      type: String,
      required: false,
      default: '0',
    },
    displaySymbol: {
      type: String,
      required: false,
      default: '',
    },
    mobileWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    dusk: {
      type: String,
      required: false,
      default: '',
    },
    testId: {
      type: String,
      required: false,
      default: null,
    },
  },
  events: {
    update: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      currentValue: 0,
    };
  },
  watch: {
    existingValue(newVal) {
      this.currentValue = isNaN(newVal) ? 0 : newVal;
    },
  },
  created() {
    this.currentValue = isNaN(this.existingValue) ? 0 : this.existingValue;
  },
  methods: {
    emitChange() {
      this.$emit('update', this.currentValue);
    },
    increaseValue() {
      if (this.max !== 0 && this.max <= this.currentValue) {
        return;
      }

      this.currentValue++;
      this.emitChange();
    },
    decreaseValue() {
      if (this.currentValue <= this.min) {
        return;
      }
      this.currentValue--;
      this.emitChange();
    },
    displayValue() {
      return this.currentValue === 0
        ? this.defaultValue
        : this.currentValue + this.displaySymbol;
    },
  },
};
</script>
